import { render, staticRenderFns } from "./DashboardCon.vue?vue&type=template&id=7c043ca0&scoped=true&"
import script from "./DashboardCon.vue?vue&type=script&lang=js&"
export * from "./DashboardCon.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCon.vue?vue&type=style&index=0&id=7c043ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c043ca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VIcon,VLayout})
